import {
  Button,
  Field,
  FieldError,
  Input,
  Label,
  Link,
} from "@cvpartner/design-system";
import { ArrowLeft } from "@cvpartner/design-system/icons/line";
import * as React from "react";
import { I18n } from "@/util/translations.ts";
import { Form } from "./shared/Form.tsx";
import { CardContent } from "./shared/LoginCard.tsx";
import {
  LoginButtonWrapper,
  LoginLinkWrapper,
  Wrapper,
} from "./shared/Modern.tsx";

export const ForgotPassword: React.FC = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [email, setEmail] = React.useState("");

  return (
    <Wrapper
      heading={I18n.t("forgot_password.header_title")}
      subheading={I18n.t("forgot_password.header_subtitle_instructions")}
      rebrandInfo={true}
    >
      <Form
        action="/forgotpassword"
        onSubmit={() => {
          setIsLoading(true);
        }}
      >
        <CardContent>
          <Field name="email" type="email">
            <Label>{I18n.t("signin.label_email")}</Label>
            <Input
              required={true}
              autoFocus={true}
              placeholder={I18n.t("signin.email_placeholder")}
              onChange={(e) => setEmail(e.target.value)}
            />
            <FieldError />
          </Field>
          <LoginButtonWrapper center={isLoading}>
            {isLoading ? (
              <Button
                type="submit"
                hierarchy="primary"
                variant="iconOnly"
                loading={true}
              />
            ) : (
              <Button type="submit" hierarchy="primary" disabled={!email}>
                {I18n.t("forgot_password.button_send")}
              </Button>
            )}
          </LoginButtonWrapper>
        </CardContent>
      </Form>
      <LoginLinkWrapper>
        <Link
          hierarchy="primary"
          href="/login"
          size="s"
          leadingIcon={ArrowLeft}
        >
          {I18n.t("forgot_password.link_back_to_signin")}
        </Link>
      </LoginLinkWrapper>
    </Wrapper>
  );
};
